module.exports = __webpack_public_path__ + "img/thumbnail_BOIRES.067a900f.png";